<template>
  <div class="cart" v-if="isCartIconVisible">
    <a :href="clickThrough" class="icon-cart-link">
      <i class="icon icon-cart"></i>
      <div class="count">
        <div class="value">{{ count }}</div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "cart-header",
  props: ["netsuite_url", "netsuite_app_url", "enable_b2c", "enable_b2b","cart_url", "country"],
  data() {
    return {
      cartmode: false,
      cartcount: 0,
      currency: window.currency,
    };
  },
  mounted() {
    let vm = this;
    var enables = new Object();
    enables["enable_b2b"] = this.enable_b2b;
    enables["enable_b2c"] = this.enable_b2c;

    vm.$store.commit("wishlist/setCartCount", 0);

    if (this.isCartIconVisible || this.$store.state.cart.isSparePartEnabled) {
      vm.setCartCount();
    }
  },
  methods: {
    setCartCount() {
      let vm = this;

      jQuery
        .ajax({
          url: this.cartUrl,
          method: "GET",
          xhrFields: {
            withCredentials: true,
          },
        })
        .done(function (res) {
          // console.log(res);

          let qtys = res.lines.map((obj) => {
            return obj.quantity;
          });

          this.cartcount = eval(qtys.join("+")) ? eval(qtys.join("+")) : 0;

          vm.$store.commit("wishlist/setCartCount", this.cartcount);
        });
    },
  },
  computed: {
    clickThrough() {
      let params = this.$store.getters["cart/getCartUrlParams"] ?? "";

      return this.netsuite_url + "cart";
    },
    userIsLoggedIn() {
      return this.$store.getters["auth/userIsLoggedIn"];
    },
    userHasCartAccess() {
      return !this.$store.getters["cart/noCartAccess"];
    },
    cartUrl() {
      return (
        this.netsuite_app_url +
        "services/LiveOrder.Service.ss?c=" +
        (window.ns_session_var ? window.ns_session_var : "") +
        "&internalid=cart&n=2&t=" +
        parseInt(Date.now() / 1000)
      );
    },
    count() {
      this.cartcount = this.$store.getters["wishlist/cartcount"];
      return this.cartcount ?? 0;
    },
    isCartIconVisible() {
      return (
        (this.$store.state.cart.isDealer && this.$store.state.cart.isSiteB2B && this.userHasCartAccess) ||
        this.$store.state.cart.isSiteB2C && this.userHasCartAccess ||
        (this.$store.getters["wishlist/cartcount"] && this.userHasCartAccess)
      );
    },
  },
};
</script>
